import { animate, query, style, transition, trigger, group } from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('isLeft => isRight', slideTo('right')),
  transition('isRight => isLeft', slideTo('left'))
  // transition('* => isLeft', slideTo('left')),
  // transition('* => isRight', slideTo('right')),
  // transition('isRight => *', slideTo('left')),
  // transition('isLeft => *', slideTo('right')),
]);

function slideTo(direction: string) {
  const optional = { optional: true };
  return [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: '0',
        [direction]: 0,
      }),
      // 🔹 Aplica la clase .router-transition dinámicamente durante la animación
      style({ class: 'router-transition' })
    ], optional),
    query(':enter', [
      style({ [direction]: '-100%' })
    ]),
    group([
      query(':leave', [
        animate('300ms ease', style({ [direction]: '100%' }))
      ], optional),
      query(':enter', [
        animate('300ms ease', style({ [direction]: '0%' }))
      ])
    ]),
    query(':leave', [
      style({ visibility: 'hidden' })
    ], optional)
  ];
}




// export const slideInAnimation = trigger('routeAnimations', [
//   transition(':increment', [ // ✅ Si el número de la nueva ruta es mayor, desliza hacia la izquierda
//     query(':enter, :leave', style({ position: 'absolute', width: '100%', height: '344px'}), { optional: true }),

//     // Sale hacia la izquierda
//     query(':leave', [
//       animate('300ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
//     ], { optional: true }),

//     // Entra desde la derecha
//     query(':enter', [
//       style({ transform: 'translateX(100%)', opacity: 0 }),
//       animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
//     ], { optional: true })
//   ]),

//   transition(':decrement', [ // ✅ Si el número de la nueva ruta es menor, desliza hacia la derecha
//     query(':enter, :leave', style({ position: 'absolute', width: '100%', height: '344px' }), { optional: true }),

//     // Sale hacia la derecha
//     query(':leave', [
//       animate('300ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
//     ], { optional: true }),

//     // Entra desde la izquierda
//     query(':enter', [
//       style({ transform: 'translateX(-100%)', opacity: 0 }),
//       animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
//     ], { optional: true })
//   ])
// ]);


// export const slideInAnimation = trigger('routeAnimations', [
//   transition('* <=> *', [
//     query(':enter, :leave', style({ position: 'absolute', width: '100%', height: '344px' }), { optional: true }),

//     // Anima la salida del componente actual (se desliza a la izquierda)
//     query(':leave', [
//       animate('300ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
//     ], { optional: true }),

//     // Anima la entrada del nuevo componente (entra desde la derecha)
//     query(':enter', [
//       style({ transform: 'translateX(100%)', opacity: 0 }),
//       animate('300ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
//     ], { optional: true })
//   ])
// ]);
